import React from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import { useIntl } from 'gatsby-plugin-intl'
import { useStyles } from './ProductInfo.style'
// import { resolveImageUrlForDeviceAndLocale } from '../../utils/resolveImageUrlForDeviceAndLocale'
import banner from '../../assets/images/after-sales-banner.png'

import bannerEn from '../../assets/images/after-sales-banner-en.png'

const ProductInfoVariation60Full = (props) => {
  const styles = useStyles()
  const { locale } = useIntl()
  // const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('sm'))
  const { t } = props

  return (
    <Box className={styles.sixtyFullVariantRoot}>
      <Box className={styles.sixtyFullImageContainer}>
        <img
          className={styles.sixtyFullMainImage}
          src={locale === 'ar' ? banner : bannerEn}
          alt="JB after sales"
        />
      </Box>

      <Box className={styles.sixtyFullContentContainer}>
        <Typography variant="body2" className={styles.sixtyFullTitle}>
          {t(props.title)}
          <strong>{t(props.titleSuffix)}</strong>
        </Typography>

        <Typography className={styles.sixtyFullDescription}>
          {t(props.subtitle)}
        </Typography>

        <Button
          className={styles.sixtyFullButton}
          variant="contained"
          color="secondary"
          href={props.ctaHref ? `/${locale}${props.ctaHref}` : '#'}
        >
          {t(props.ctaText || 'Read More')}
        </Button>
      </Box>
    </Box>
  )
}
export default ProductInfoVariation60Full
